import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useTextFieldStyles = makeStyles(theme => ({
	root: {
		borderTopLeftRadius: '4px',
		borderTopRightRadius: '4px',
		marginTop: 2,
		marginBottom: 0,
		width: '100px',
		overflow: 'hidden',
		'& .MuiInput-root': {
			backgroundColor: COLORS.BACKGROUND_INPUT,
			'&:hover': {
				backgroundColor: COLORS.BACKGROUND_INPUT_HOVER
			}
		},
		'& .MuiInput-inputMarginDense': {
			padding: 5,
			paddingRight: 2
		},
		'& .MuiInput-underline': {
			'&:before': {
				borderBottom: 0
			},
			'&:hover:before': {
				borderBottom: 0
			}
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: errors => (!errors.ambientTemperature ? COLORS.PRIMARY : 'red')
		},
		'& .MuiInput-adornedStart': {
			paddingLeft: 7
		},
		'& .MuiInput-adornedEnd': {
			paddingRight: 7
		},
		'& .MuiInputBase-root': {
			fontSize: theme.typography.body2.fontSize
		}
	}
}));
